var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_3001)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.056 37.8028C33.652 38.3861 33.6068 39.3766 32.9193 39.8535C29.4773 42.2487 25.3696 43.5575 21.1463 43.6047C9.9928 43.7401 0.391783 34.7916 0.0123718 23.8793C-0.356597 13.2541 7.57101 4.38822 17.9404 2.95414C18.7628 2.84003 19.4929 3.50853 19.4929 4.3218V24.5291L33.056 37.8028Z",
    fill: "#828284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5569 19.0101C43.8364 8.83705 35.5293 0.707824 25.1338 0.00271201C24.3402 -0.0475314 23.6719 0.607336 23.6719 1.38568V20.4407H43.1446C43.9399 20.4407 44.6082 19.7867 44.5569 19.0101ZM45.931 24.5283H25.2818L39.0311 37.9833C39.5532 38.4943 40.4234 38.5394 40.9621 38.0413C44.4149 34.8668 46.6595 30.636 47.3259 26.0459C47.4451 25.2428 46.762 24.5283 45.931 24.5283Z",
    fill: "#828284"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_3001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.fc45af1dd355ac174208bea40d5dcdb2.svg";
export { ForwardRef as ReactComponent };